module.exports = __webpack_public_path__ + "img/njcbMobileBg.5bbcaa90.png";